/*-- import aliases -----------
'!/...' -> project root
'~/...' -> js folder root
-----------------------------*/
import { setup } from "~/core";
setup();

import "~/global/_body";
import "~/global/_header";
import "~/global/_footer";
import "~/global/_siteModals";

import "~/components/_accordion";
import "~/components/_caseStudies";
import "~/components/_statCounter";
import "~/components/_forms";
import "~/components/_listingSearch";
import "~/components/_leadershipListingCard";
import "~/components/_testimonial";
import "~/components/_homeHero";
import "~/components/_search";
import "~/components/_market-button-dropdown";
import "~/components/market-theme-selector";
import "~/components/market-faq-section";
import "~/components/market-image-overlay";
